var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"text-sm text-red-700 font-semibold"},_vm._l((_vm.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }